<template>
	<div>
		<AttachmentSection :files='files' v-if='files' />
		<InformationSection :sections='information' />
			<v-sheet dark color="#16528E">
				<v-card-text class="font-weight-light text-uppercase">
					<span
						class="display-1 font-weight-light text-uppercase"
						style="opacity: 0.8"
						v-text='"STAFF"'
					/>
				</v-card-text>
			</v-sheet>		
			<v-card class="body-1">
			<Staff :employees='staff'/>
			</v-card>

	</div>
</template>

<script>
import ContentService from '@/services/ContentService'

import InformationSection from '@/components/base/InformationSection'
import AttachmentSection from '@/components/base/AttachmentSection'
import Staff from '@/components/base/AboutEmployees'


export default {
	name: 'About',

	components: {
		InformationSection,
		AttachmentSection,
		Staff
	},

	metaInfo: {
    title: 'About'
  },

	data() {
		return {
			information: [],
			files: [],
			staff: []
		}
	},
	async created() {
		const {text, vision, guidelines, files, staff} = await ContentService.get('about')

		this.files = files
		this.information.push({ title: '', text })
		this.information.push({ title: 'Our Vision', text: vision })
		this.information.push({ title: 'Guiding Principles', text: guidelines })
		this.staff = staff
	},
}
</script>

<style>
</style>